const blueGrey200Color = '#97A9B2';

export default blueGrey200Color;
